import { render, staticRenderFns } from "./ApmsBasicCanteenMaterialCategory.vue?vue&type=template&id=2988c35e&scoped=true&"
import script from "./ApmsBasicCanteenMaterialCategory.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicCanteenMaterialCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988c35e",
  null
  
)

export default component.exports